/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon64Regular = forwardRef('ArrowCollapseCVClosedIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M37.303 24.818a7.5 7.5 0 0 1-10.606 0L10.439 8.561a1.5 1.5 0 0 1 2.122-2.121l16.257 16.257a4.5 4.5 0 0 0 6.364 0L51.44 6.44a1.5 1.5 0 1 1 2.12 2.12L37.304 24.819Z" }),
        React.createElement("path", { d: "M37.303 39.182a7.5 7.5 0 0 0-10.606 0L10.439 55.439a1.5 1.5 0 0 0 2.122 2.121l16.257-16.257a4.5 4.5 0 0 1 6.364 0L51.44 57.56a1.5 1.5 0 1 0 2.12-2.12L37.304 39.181Z" })));
});
